export const TEMP_SELECTED_MATERIAL_LAST_ID = 999999999;

export enum MaterialsSetsPermissions {
  READ_MATERIALS_SET_DOWNLOAD_BUTTON = 'read_materials_set_download_button',
  READ_MATERIALS_SET_DOWNLOAD_SEPARATELY_BUTTON = 'read_materials_set_download_separately_button',
  READ_MATERIALS_SET_CLEAR_BUTTON = 'read_materials_set_clear_button'
}
